module.exports = __webpack_public_path__ + "static/media/2.5d815c1d.jpg";